import styled from 'styled-components';

const BrandCardContainer = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
`;

export default BrandCardContainer;
